import React, { useContext, useMemo } from 'react';

import { Formik } from 'formik';
import * as Yup from 'yup';

import { PacksDispatchContext, PacksContext } from '../ApiProvider';

import { saveAssigns } from 'Helpers/costPacks';

import Button from 'CommonComponents/Button';
import TextFormField from 'CommonComponents/TextFormField';

const PackSchema = Yup.object().shape({
    name: Yup.string().required($t('This value is required')),
});

export default function PackForm({ id, type }) {
    const apiCall = useContext(PacksDispatchContext);
    const packs = useContext(PacksContext).packs;

    const details = useMemo(() => {
        return id ? packs.find((pack) => pack.id == id) : { name: '', id: false };
    }, [packs, id]);

    const handleDelete = () => {
        apiCall('packDelete', details);
        saveAssigns();
    };

    return (
        <Formik
            enableReinitialize
            initialValues={{
                name: details.name || '',
            }}
            validationSchema={PackSchema}
            onSubmit={(values, actions) => {
                const data = { ...details, ...values };
                data.pack_contractor = type === 'createContractorPack' ? 1 : 0;

                apiCall('packEdit', data);
                saveAssigns();
            }}
        >
            {({ isSubmitting, handleSubmit }) => (
                <>
                    <TextFormField label={$t('Name')} type="text" required={true} name="name"></TextFormField>

                    <div className="modal__footer">
                        <Button variant="secondary" onClick={() => apiCall('form', false)} disabled={isSubmitting}>
                            {$t('Cancel')}
                        </Button>
                        <Button
                            variant="danger"
                            className={details?.commitment_exists || isSubmitting ? 'tw-opacity-50 tw-cursor-not-allowed' : ''}
                            onClick={() => {
                                if (isSubmitting || details.commitment_exists) {
                                    return;
                                }
                                handleDelete();
                            }}
                            disabled={isSubmitting}
                        >
                            {$t('Delete')}
                        </Button>
                        <Button variant="primary" onClick={handleSubmit} disabled={isSubmitting}>
                            {details.id ? $t('Update') : $t('Create')}
                        </Button>
                    </div>
                </>
            )}
        </Formik>
    );
}
